module.exports = __webpack_public_path__ + "static/partnerABCWallet-7705bd5f74b76d96981960874a780fd1.svg";